(function () {
  const TARGET_NAMES = ["Mama", "Papa", "Opa", "Oma", "Schatz"];
  const CART_SELECTOR = ".ocu-cart-drawer";
  const LIST_SELECTOR = ".ocu-cart-line-items";
  const ITEM_SELECTOR = ".ocu-cart-line-item-wrapper";
  const TITLE_SELECTOR = ".ocu-cart-line-item-product-title span";
  const VARIANT_SELECTOR = ".ocu-cart-line-item-product-variant span";

  function getCleanVariantText(raw) {
    const text = String(raw || "").trim();
    if (!text) return "";

    const match = text.match(/^[^:]+:\s*(.+)$/);
    return (match ? match[1] : text).trim();
  }

  function replaceLeadingNameWithVariant(title, variant) {
    const cleanTitle = String(title || "").trim();
    const cleanVariant = String(variant || "").trim();

    if (!cleanTitle || !cleanVariant) return cleanTitle;
    if (!TARGET_NAMES.includes(cleanVariant)) return cleanTitle;

    for (const name of TARGET_NAMES) {
      const prefix = `${name},`;
      if (cleanTitle.startsWith(prefix)) {
        return `${cleanVariant}${cleanTitle.slice(name.length)}`;
      }
    }

    return cleanTitle;
  }

  function updateItem(item) {
    const titleNode = item.querySelector(TITLE_SELECTOR);
    const variantNode = item.querySelector(VARIANT_SELECTOR);
    if (!titleNode) return;

    const originalTitle =
      titleNode.dataset.originalTitle || titleNode.textContent.trim();

    titleNode.dataset.originalTitle = originalTitle;

    const variantText = getCleanVariantText(variantNode?.textContent || "");
    const nextTitle = replaceLeadingNameWithVariant(originalTitle, variantText);

    if (titleNode.textContent.trim() !== nextTitle) {
      titleNode.textContent = nextTitle;
    }
  }

  function updateAll(root) {
    if (!root) return;
    root.querySelectorAll(ITEM_SELECTOR).forEach(updateItem);
  }

  function getItemsLength(list) {
    return list.querySelectorAll(ITEM_SELECTOR).length;
  }

  function attachListObserver(list) {
    if (!list || list.dataset.titlePrefixObserverAttached === "true") return;

    list.dataset.titlePrefixObserverAttached = "true";

    let previousItemsLength = getItemsLength(list);

    updateAll(list);

    const observer = new MutationObserver(() => {
      const nextItemsLength = getItemsLength(list);

      if (nextItemsLength !== previousItemsLength) {
        previousItemsLength = nextItemsLength;
        updateAll(list);
      }
    });

    observer.observe(list, {
      childList: true,
      subtree: true,
    });
  }

  function initInCart(cart) {
    if (!cart) return;

    cart.querySelectorAll(LIST_SELECTOR).forEach(attachListObserver);
    updateAll(cart);

    if (cart.dataset.cartObserverAttached === "true") return;
    cart.dataset.cartObserverAttached = "true";

    const cartObserver = new MutationObserver(() => {
      cart.querySelectorAll(LIST_SELECTOR).forEach(attachListObserver);
    });

    cartObserver.observe(cart, {
      childList: true,
      subtree: true,
    });
  }

  function tryInitCart() {
    const cart = document.querySelector(CART_SELECTOR);
    if (!cart) return false;

    initInCart(cart);
    return true;
  }

  function boot() {
    if (tryInitCart()) return;

    const bodyObserver = new MutationObserver(() => {
      if (tryInitCart()) {
        bodyObserver.disconnect();
      }
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();